.centerColumn {
    padding: 0;
}

.centerBlocks {
    margin-bottom: 2em;
}

.centerBlocks td {
    color: #333;
}

.centerBlocks td a {
    font-weight: bold;
    color: #3366ff;
    text-decoration: none;
}

.centerBlocks td a:hover {
    color: #ff9900;
}

.centerMainTitle {
    margin-bottom: 1em;
    padding: 3px 8px;
    border-left: 8px solid #4584e0;
    border-bottom: 1px solid #4584e0;
    font-size: 16px;
    color: #333;
}

.centerMainContent {
    margin-bottom: 2em;
    font-size: 90%;
    line-height: 120%;
}

.centerLeftColumn {
    width: 50%;
    padding-right: 6px;
}

.centerRightColumn {
    width: 50%;
    padding-left: 6px;
}

.breadclumbs {
    margin-bottom: 1em;
    padding: 0 5px;
    font-size: 90%;
    color: #999;
}
